var $ = jQuery;
$(document).ready(function ($) {
    const menu = $('.header-mobileMenu');
    const menuBtn = $('#menuOpenBtn');
    const btnClose = $('#menuCloseBtn');
    const isRTL = !!$('html').attr('dir');

    function menuItemToggle() {
        const item = $('.header-menu > .menu-item-has-children');
        item.on('click', function (e) {
            if (e.target !== this)
                return;
            $(this).toggleClass('active')
            const subMenu = $(this).find('.sub-menu');
            subMenu.eq(0).stop().toggleClass('opened')
        })

    }

    function menuOpen() {
        menuBtn.click(function () {
            $(this).css('display', 'none')
            menu.addClass('opened');
            btnClose.css('display', 'block');
           /* $('body').addClass('overflow-hidden');*/
        })
    }

    function menuClose() {
        btnClose.click(function () {
            menu.removeClass('opened');
            btnClose.css('display', 'none');
            menuBtn.css('display', 'flex');
           /* $('body').removeClass('overflow-hidden')*/
        })
    }

    function faqAccorion() {
        $('.faq-title').click(function () {
            $(this).find('.faq-sign').toggleClass('opened');
            $(this).next('.faq-descr').stop().slideToggle('fast')
        })
    }

    function video_play() {
        const video = $('.banner-video video');
        if (!!video.length) {
            $('.banner-video video').get(0).play();
        }
    }

    function slider_on_banner() {
        const banner = $('#banner-first');
        const bannerThird = $('#banner-third');
        const pathSlider = $('#steps');

        if (banner) {
            banner.slick({
                dots: false,
                arrows: false,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                draggable: false,
                //autoplay: true,
                autoplaySpeed: 4000,
                rtl: isRTL
            });

            change_slides_on_click('.banner-li', banner, '#banner-menu-overlay');
        }

        if (bannerThird) {
            bannerThird.slick({
                dots: false,
                arrows: false,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                draggable: false,
                // autoplay: true,
                autoplaySpeed: 4000,
                rtl: isRTL
            })
            change_slides_on_click('.banner-third-li', bannerThird, '#banner-menu-overlay');
        }

        if (pathSlider) {
            pathSlider.slick({
                dots: true,
                arrows: false,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                draggable: true,
                //autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: isRTL
            });

            change_slides_on_click('.steps-buttons-item', pathSlider, '#steps-overlay')
        }
    }

    function change_slides_on_click($button, $slider, $overlay) {
        let buttonId;
        $($button).on('click', function () {
            buttonId = $(this).attr('data-index');
            $($button).removeClass('active');
            $(this).addClass('active');
            $slider.slick('slickGoTo', buttonId)

        });
        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $($overlay).css('display', 'block')
            $($button).removeClass('active');
            $($button + '[data-index="' + nextSlide + '"]').addClass('active')
        });

        $slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $($overlay).css('display', 'none')
        });
    }

    function second_banner() {
        const bannerSecond = $('#banner-second-segments');

        if (bannerSecond) {
            $('.banner-second-item').on('click', function () {
                $('.banner-second-item').removeClass('active');
                $(this).addClass('active')
            });

            $('#banner-second-slider').slick({
                dots: true,
                arrows: false,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                // autoplay: true,
                autoplaySpeed: 4000,
                rtl: isRTL
            });

            change_slides_on_click('.banner-second-item', $('#banner-second-slider'), '#banner-menu-overlay');
        }
    }

    function modal_interaction() {
        $('.modal-trigger').on('click', function () {
            $(this).siblings('.modal').addClass('opened');
            $('body').css('overflow', 'hidden');
        })

        $('.close-trigger').on('click', function () {
            $('.modal').removeClass('opened');
            $('body').css('overflow', 'auto');
        })

        $('.modal-overlay').on('click', () => {
            $('body').css('overflow', 'auto');
            $('.modal').removeClass('opened');
        })

        $(document).on('keydown', (e) => {
            if (e.keyCode === 27) $('.close-trigger').click();
        })
        
    }

    function reviews_slider() {
        const slider = $('#reviews-slider');
        if (slider) {
            slider.slick({
                dots: true,
                arrows: true,
                speed: 500,
                //autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: "<div class='slick-next'>1</div>",
                prevArrow: "<div class='slick-prev'>2</div>",
                rtl: isRTL
            });
        }

    }

    video_play();
    menuOpen();
    menuClose();
    menuItemToggle();
    faqAccorion();
    modal_interaction();
    slider_on_banner();
    second_banner();
    reviews_slider();


    $('.packages-card-disable').on('click', function (e) {
        e.preventDefault();
    })

    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        if ($(this).attr('href').length > 1) {
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);
        }
    });
})

const btn = $('#top');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});